export default __webpack_public_path__ + "static/media/background-6.d1066077.jpg";